export const formatAddress = (address) => {
  if (!address) return "...";
  const first = address?.substring(0, 8);
  const last = address?.substring(address?.length - 5, address?.length);
  return first + "..." + last;
};

export const formatHash = (address) => {
  if (!address) return "...";
  const first = address?.substring(0, 15);
  const last = address?.substring(address?.length - 5, address?.length);
  return first + "..." + last;
};
